import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface TrashIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const TrashIcon = ({ className, ...props }: TrashIconProps) => (
  <svg
    className={cn("text-system-red", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.1111 9.33337L17.3378 19.419C17.1884 20.269 16.45 20.8889 15.5869 20.8889H8.41311C7.55005 20.8889 6.81166 20.269 6.6622 19.419L4.8889 9.33337"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
    <path
      d="M20 6.66664H15M4 6.66664H9M9 6.66664V4.88886C9 3.90702 9.79594 3.11108 10.7778 3.11108H13.2222C14.2041 3.11108 15 3.90702 15 4.88886V6.66664M9 6.66664H15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);

export default TrashIcon;
